module.exports = __webpack_public_path__ + "img/professioneel-etiket-bierfles-quadruppel-blond-business-beer-nederland-thumbnail.3a65f93d.png";